import API from './API.js';
export default class Pages extends API {
    constructor() {
        super('pages');
    }

}
